
import { Component, Vue, Prop } from 'vue-property-decorator';
import { adcode } from '@/const/AdCode';

@Component({
  name: 'pickerAddress',
  components: {
  }
})
export default class extends Vue {
  @Prop({
    type: Boolean,
    default: false
  })
  dialogAddressVisible!: Boolean;
  private positionResult:any={}
  private test:any='';
  private lAreaData: any=[];
  created() {
    this.loadPositionPicker();
    this.lAreaData = adcode;
  }
  private getPCD(adcode:any, list:any) {
    if (adcode) {
      var b = adcode.substring(4, 0) + '00';
      var a = adcode.substring(2, 0) + '0000';
      this.address.province = this.lAreaData[a].id;
      this.address.city = this.lAreaData[b].id;
      this.address.district = this.lAreaData[adcode].id;
      this.address.province_name = this.lAreaData[a].name;
      this.address.city_name = this.lAreaData[b].name;
      this.address.district_name = this.lAreaData[adcode].name;
    }
  }
  loadPositionPicker() {
    let _this = this;
    AMapUI.load(['ui/misc/PositionPicker'], function(PositionPicker: any) {
      var map = new AMap.Map('pickerContainer', {
        zoom: 16,
        showZoomBar: true
      });

      AMap.plugin(['AMap.Geolocation', 'AMap.Autocomplete', 'AMap.PlaceSearch', 'AMap.ToolBar'], function() {
        var geolocation = new AMap.Geolocation({
        // 是否使用高精度定位，默认：true
          enableHighAccuracy: true,
          // 设置定位超时时间，默认：无穷大
          timeout: 10000,
          // 定位按钮的停靠位置的偏移量，默认：Pixel(10, 20)
          buttonOffset: new AMap.Pixel(10, 20),
          //  定位成功后调整地图视野范围使定位位置及精度范围视野内可见，默认：false
          zoomToAccuracy: true,
          //  定位按钮的排放位置,  RB表示右下
          buttonPosition: 'LB'
        });
        map.addControl(geolocation);
        geolocation.getCurrentPosition();
        AMap.event.addListener(geolocation, 'complete', onComplete);// 返回定位信息
        AMap.event.addListener(geolocation, 'error', onError);// 返回定位出错信息

        function onComplete(data:any) {
        // data是具体的定位信息
        }

        function onError(data:any) {
        // 定位出错
        }
        var autoOptions = {
          // 城市，默认全国
          // city: '北京',
          // 使用联想输入的input的id
          input: 'tipinput'
        };
        var autocomplete = new AMap.Autocomplete(autoOptions);

        var placeSearch = new AMap.PlaceSearch({
          city: '北京',
          map: map
        });
        AMap.event.addListener(autocomplete, 'complete', function(e:any) {
          // TODO 针对选中的poi实现自己的功能
        });
        AMap.event.addListener(autocomplete, 'select', function(e:any) {
          // TODO 针对选中的poi实现自己的功能
          placeSearch.search(e.poi.name);
        });
      });

      //   TODO:事件绑定、结果处理等
      var positionPicker = new PositionPicker({

        mode: 'dragMap', // 设定为拖拽地图模式，可选'dragMap'、'dragMarker'，默认为'dragMap'
        map: map // 依赖地图对象

      });
      positionPicker.on('success', function(positionResult:any) {
        _this.positionResult = positionResult;
      });
      positionPicker.on('fail', function(positionResult:any) {
        // 海上或海外无法获得地址信息
      });
      map.addControl(new AMap.ToolBar({
        liteStyle: true
      }));
      positionPicker.start();
    });
  }

  private close() {
    this.$emit('closeAddress', false);
  }
  private address:any={};
  private conformAddress() {
    this.getPCD(this.positionResult.regeocode.addressComponent.adcode, this.lAreaData);
    this.address.address = this.positionResult.address;
    this.address.longitude = this.positionResult.position.lng;
    this.address.latitude = this.positionResult.position.lat;
    this.address.adcode = this.positionResult.regeocode.addressComponent.adcode;
    this.$emit('closeAddress', false);
    this.$emit('positionPicker', this.address);
  }
}
